import { fallback } from "@tanstack/zod-adapter"
import { z } from "zod"

import { PAY_FILE_DEFAULT_STATUSES } from "../constants"

import { PayFileSortField, PayFileStatus, PayFileType, SortingOrder } from "@/graphql/codegen/graphql"

// z.string().date() validates strict ISO-8601 calendar dates (rejects 2026-02-30, 2026-13-01, etc.).
const isoDateSchema = fallback(z.string().date().optional(), undefined)

export const payFileSearchParamsSchema = z.object({
  // Sort defaults per AK-5102 AC (initial sort by Creation Date). Required-with-fallback so the
  // default is applied on first load.
  field: fallback(z.nativeEnum(PayFileSortField), PayFileSortField.CreatedOn),
  order: fallback(z.nativeEnum(SortingOrder), SortingOrder.Desc),

  // AK-6851: Pending + Approved + Processing (the backend list default) is the real default of `statuses`, so the
  // chips and the drawer show it like any other filter. An explicit empty array stays empty (no status filter);
  // only an absent or invalid value falls back to the default.
  statuses: fallback(
    z.array(z.nativeEnum(PayFileStatus)).default(PAY_FILE_DEFAULT_STATUSES),
    PAY_FILE_DEFAULT_STATUSES
  ),
  // Never a real default: a present-but-invalid value (a hand-edited URL) is coerced to undefined instead of erroring.
  type: fallback(z.nativeEnum(PayFileType).optional(), undefined),
  scheduledPayDateFrom: isoDateSchema,
  scheduledPayDateTo: isoDateSchema,
})

export type PayFileSearchParams = z.infer<typeof payFileSearchParamsSchema>
